module.exports = __webpack_public_path__ + "img/about_business_area01.57bd4e76.svg";